<template>
      <a-col>
        <div type="flex" justify="center" align="center" class="provisioning_tips_container">
            <p v-if="!isCountDownEnd" class="provisioning_code_tips">{{countDownNum}}秒後重新寄送</p>
            <p v-else>未收到驗證碼？ <a class="provisioning_hyperlink" @click.prevent="handleResendVerificationCode">重新寄送</a></p>
        </div>
        <div>
            <a-button block class="green_bg step_btn" size="large" @click="verifyCode"><span>驗證 </span></a-button>
        </div>
        <div type="flex" justify="center" align="center" class="error_phone_tips">
            <p>若您的手機號碼有誤，請回 <a class="provisioning_hyperlink" @click.prevent="backToPrePage">上一步</a> 修改</p>
        </div>
      </a-col>
</template>

<script>
    import { bus } from "../../main";
    export default {
        data() {
            return {
                countDownNum: 60,
                isCountDownEnd: false,
                timerFunc: null,
                currentCodeArr: [
                    {
                        value: ''
                    },
                    {
                        value: ''
                    },
                    {
                        value: ''
                    },
                    {
                        value: ''
                    },
                    {
                        value: ''
                    },
                    {
                        value: ''
                    }
                ],
            }
        },
        created() {
            bus.$on("passCurrentCode", data => {
                console.log('data', data);
                this.currentCodeArr = data;
            });            
        },
        methods: {
            handleCountdown() {
                this.countDownNum --;
                if (this.countDownNum === 0){
                    clearInterval(this.timerFunc);
                    this.countDownNum = 60;
                    this.isCountDownEnd = true;
                }
            },
            handleResendVerificationCode() {
                this.isCountDownEnd = false;
                this.timerFunc = setInterval(this.handleCountdown, 1000);
            },
            verifyCode() {
                console.log('currentCodeArr', this.currentCodeArr);
                const emptyCode = this.currentCodeArr.find(code => !code.value);
                if (emptyCode) {
                    bus.$emit('emptyCode', true);
                    bus.$emit('errorCode', false);
                    return;
                }
                else {
                    bus.$emit('emptyCode', false);
                    let numStr = '';
                    this.currentCodeArr.forEach(element => {
                        numStr += element.value.toString();
                    });
                    if(numStr === '123456') {
                        bus.$emit('errorCode', true);
                    }
                    else {
                        bus.$emit('errorCode', false);
                        this.$router.push(`/provisioning/step4`);
                    }                    
                }
            },
            backToPrePage() {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.timerFunc = setInterval(this.handleCountdown, 1000);
        },
        beforeDestroy() {
            clearInterval(this.timerFunc);
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .provisioning_tips_container {
      margin: 27px auto;
      .provisioning_code_tips {
          color: rgba(0, 0, 0, 0.25);
      }
  }

  .provisioning_hyperlink {
        color: #7CB305;
  }

  .error_phone_tips {
      margin-top: 12px;
      color: #343741;
  }
</style>